<template>
  <CModalNative
    :visible="internalVisible"
    :alignment="centered ? 'center' : undefined"
    :size="['sm', 'lg', 'xl'].includes(size) ? size : undefined"
    :backdrop="backdrop"
    :scrollable="scrollable"
    :fullscreen="fullscreen"
    :unmount-on-close="unmountOnClose"
    :keyboard="keyboard"
    :transition="transition"
    :focus="focus"
    :content-class-name="computedContentClassName"
    v-bind="$attrs"
    @close="handleClose"
    @show="handleShow"
    @close-prevented="$emit('close-prevented')"
  >
    <template v-if="$slots['header-wrapper']">
      <slot name="header-wrapper" />
    </template>
    <div
      v-else-if="title || $slots.header"
      class="modal-header"
    >
      <slot name="header">
        <h5 class="modal-title">
          {{ title }}
        </h5>
      </slot>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        @click="handleClose"
      />
    </div>
    <div class="modal-body">
      <slot />
    </div>
    <template v-if="$slots['footer-wrapper']">
      <slot name="footer-wrapper" />
    </template>
    <div
      v-else-if="$slots.footer"
      class="modal-footer"
    >
      <slot name="footer" />
    </div>
  </CModalNative>
</template>

<script>
import { CModal as CModalNative } from '@coreui/vue-pro'

export default {
  name: 'CModal',
  components: { CModalNative },
  inheritAttrs: false,
  props: {
    visible: { type: Boolean, default: false },
    show: { type: Boolean, default: false },
    title: { type: String, default: '' },
    size: { type: String, default: '' },
    color: { type: String, default: '' },
    centered: { type: Boolean, default: false },
    closeOnBackdrop: { type: [Boolean, String], default: true },
    scrollable: { type: Boolean, default: false },
    fullscreen: { type: [Boolean, String], default: false },
    unmountOnClose: { type: Boolean, default: false },
    keyboard: { type: Boolean, default: true },
    transition: { type: Boolean, default: true },
    focus: { type: Boolean, default: true },
    contentClassName: { type: String, default: '' },
  },
  emits: ['close', 'show', 'close-prevented', 'update:visible', 'update:show'],
  data() {
    return {
      internalVisible: this.visible || this.show,
    }
  },
  computed: {
    backdrop() {
      if (this.closeOnBackdrop === false) return 'static'
      return this.closeOnBackdrop === true ? true : this.closeOnBackdrop
    },
    computedContentClassName() {
      let cls = this.contentClassName
      if (this.color) cls += ` modal-content-${this.color}`
      return cls.trim()
    },
  },
  watch: {
    visible(val) {
      this.internalVisible = val
    },
    show(val) {
      this.internalVisible = val
    },
  },
  methods: {
    handleClose() {
      this.internalVisible = false
      this.$emit('update:visible', false)
      this.$emit('update:show', false)
      this.$emit('close')
    },
    handleShow() {
      this.$emit('show')
    },
  },
}
</script>
